import moment from 'moment';

export const formatDate = (date: string, format = 'DD-MM-YYYY') => {
  if (date === null || date === undefined) {
    return '';
  }
  const momentDate = moment(date.replace('Z', ''));

  if (!momentDate.isValid()) {
    return '';
  }
  return momentDate.format(format);
};
